import { Send } from "lucide-react";

export const NewsletterTab = ({ sendNewsletter }) => (
  <div className="border border-white/10 bg-[#121418] p-8 max-w-2xl">
    <h3 className="font-serif text-2xl text-[#EBE9E1] mb-3">"This Week from the Archive"</h3>
    <p className="text-[#8A8F98] text-sm mb-6">
      A twice-weekly email digest featuring the next <strong className="text-[#C5A059]">2–3 newly surfaced recordings</strong>, sent automatically every
      <strong className="text-[#C5A059]"> Tuesday & Friday</strong> to all newsletter subscribers. Send the next edition now to preview it.
      (Requires a SendGrid API key in the backend to actually deliver emails.)
    </p>
    <button data-testid="admin-send-newsletter" onClick={sendNewsletter} className="btn-primary px-8 py-3 font-medium flex items-center gap-2">
      <Send size={16} /> Send This Week's Edition Now
    </button>
  </div>
);
